// Clamp negatives to 0 so one malformed dimension can't invalidate the whole
// grid-template-columns string; a non-finite value (NaN/Infinity) returns undefined
// so the caller drops that dimension and falls back to a sensible track.
function clamp(value) {
    return value === undefined || !Number.isFinite(value) ? undefined : Math.max(0, value);
}
// Compiles a `grid` layout's columns into a `grid-template-columns` value; `undefined` in `auto` layout.
export function computeGridTemplateColumns(columnLayout) {
    if (columnLayout.type !== 'grid') {
        return undefined;
    }
    return columnLayout.columns.map(compileColumnTrack).join(' ');
}
function compileColumnTrack(column) {
    var _a;
    const { size, minWidth, maxWidth } = column;
    const min = `${(_a = clamp(minWidth)) !== null && _a !== void 0 ? _a : 0}px`;
    if (typeof size === 'number') {
        const px = clamp(size);
        if (px !== undefined) {
            return `${px}px`; // fixed track — minWidth/maxWidth don't apply.
        }
    }
    else if (size) {
        const flex = clamp(size.flex);
        if (flex !== undefined) {
            return `minmax(${min}, ${flex}fr)`; // weighted track — the type forbids a maxWidth (can't cap an fr track).
        }
    }
    // No (or non-finite) size: a hard-capped track (maxWidth) or the default growable track.
    const max = clamp(maxWidth);
    return max !== undefined ? `minmax(${min}, ${max}px)` : `minmax(${min}, 1fr)`;
}
//# sourceMappingURL=grid-template-columns.js.map